;(() => {
  const angular = window.angular;

  const STRONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

  ManagerPasswordCtrl.$inject = ['$scope', 'Manager', 'AppUtils'];

  angular
    .module('app')
    .component('managerPasswordForm', {
      template:'<form name="ctrl.changePasswordForm" class="validate" novalidate autocomplete="off" ng-class="{transparent: ctrl.saving}"><div class="modal-header"><span translate>buttons.change</span> <span translate>entities._all.password</span></div><div class="modal-body"><fieldset><legend><span class="text-info">{{ctrl.user.name}} {{ctrl.user.surname}}</span></legend><div class="form-group" show-errors><label class="control-label" for="password-input"><span translate>entities._all.password</span></label> <input ng-model="ctrl.changeForm.password" id="password-input" ng-change="ctrl.onChange()" ng-blur="ctrl.onBlur()" type="password" class="form-control" name="password" required ng-minlength="ctrl.minPassLength" translate-attr="::{placeholder: \'entities._all.password\'}"><p class="help-block" ng-messages="ctrl.changePasswordForm.password.$error"><span ng-message="required" translate>form.errors.required</span> <span ng-message="minlength" translate>form.errors.minLength</span> <span ng-message="weak" translate>entities.user.password.weak</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div><div class="form-group" show-errors><label class="control-label" for="password-confirm" translate>entities.user.password.confirm</label> <input ng-model="ctrl.changeForm.repeatPassword" id="password-confirm" ng-change="ctrl.onChange()" ng-blur="ctrl.onBlur()" type="password" class="form-control" name="repeatPassword" required ng-minlength="ctrl.minPassLength" translate-attr="::{placeholder: \'entities._all.password\'}"><p class="help-block" ng-messages="ctrl.changePasswordForm.repeatPassword.$error"><span ng-message="required" translate>form.errors.required</span> <span ng-message="minlength" translate>form.errors.minLength</span> <span ng-message="password_mismatch" translate>form.errors.passwordMismatch</span></p></div><ul class="list-unstyled marginB10" style="font-size: 12px"><li ng-class="ctrl.requirements.length ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.length ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLength</span></li><li ng-class="ctrl.requirements.upper ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.upper ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqUpper</span></li><li ng-class="ctrl.requirements.lower ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.lower ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqLower</span></li><li ng-class="ctrl.requirements.digit ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.digit ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqDigit</span></li><li ng-class="ctrl.requirements.symbol ? \'text-success\' : \'text-muted\'"><i class="fas fa-fw" ng-class="ctrl.requirements.symbol ? \'fa-check-circle\' : \'fa-circle\'"></i> <span translate>entities.user.password.reqSymbol</span></li></ul></fieldset></div><div class="alert alert-warning no-margin text-center" ng-show="ctrl.saveError">{{ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="ctrl.changePassword()" translate>buttons.change</button></div></form><spinner css-class="\'small\'" show-logo="true" show="ctrl.loading"></spinner>',
      controller: ManagerPasswordCtrl,
      controllerAs: 'ctrl',
      bindings: {
        resolve: '<',
        modalInstance: '<'
      }
    });

  function ManagerPasswordCtrl ($scope, Manager, utils) {
    const vm = this;

    vm.$onInit = function () {
      vm.user = vm.resolve.user;

      vm.changeForm = {};
      vm.minPassLength = 8;
      vm.requirements = { length: false, upper: false, lower: false, digit: false, symbol: false };

      vm.onChange = onChange;
      vm.onBlur = onBlur;
      vm.changePassword = changePassword;
    };

    function changePassword () {
      let password = vm.changeForm.password;
      let repeatPassword = vm.changeForm.repeatPassword;

      if (password && repeatPassword && password !== repeatPassword) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', false);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', false);
      }

      vm.changePasswordForm.password.$setValidity('weak', STRONG_PASSWORD_REGEX.test(password || ''));

      $scope.$broadcast('show-errors-check-validity');

      if (!vm.changePasswordForm.$valid) {
        return;
      }

      vm.loading = true;
      Manager
        .prototype$patchAttributes({ id: vm.user.id }, { password: password })
        .$promise
        .then(() => {
          vm.loading = false;
          vm.modalInstance.close();
        })
        .catch(response => {
          vm.loading = false;
          vm.saveError = utils.getHTTPError(response);
        });
    }

    function onChange () {
      let password = vm.changeForm.password || '';
      let repeatPassword = vm.changeForm.repeatPassword || '';

      vm.requirements.length = password.length >= vm.minPassLength;
      vm.requirements.upper = /[A-Z]/.test(password);
      vm.requirements.lower = /[a-z]/.test(password);
      vm.requirements.digit = /\d/.test(password);
      vm.requirements.symbol = /[^A-Za-z0-9]/.test(password);

      if (password.length < vm.minPassLength && repeatPassword.length < vm.minPassLength) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', true);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', true);
      }
    }

    function onBlur () {
      let password = vm.changeForm.password;
      let repeatPassword = vm.changeForm.repeatPassword;
      if (password && repeatPassword && password !== repeatPassword) {
        vm.changePasswordForm.password.$setValidity('password_mismatch', false);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', false);
      } else {
        vm.changePasswordForm.password.$setValidity('password_mismatch', true);
        vm.changePasswordForm.repeatPassword.$setValidity('password_mismatch', true);
      }
    }
  }
})();
